import React, { useState } from 'react';
import { migratePasswords } from '../../utils/password-migration';

const MigratePasswordsButton = () => {
  const [migrating, setMigrating] = useState(false);
  const [result, setResult] = useState(null);

  const handleMigration = async () => {
    if (migrating) return;
    
    if (!window.confirm('This will update all user passwords to use secure hashing. Continue?')) {
      return;
    }
    
    setMigrating(true);
    setResult(null);
    
    try {
      const migrationResult = await migratePasswords();
      setResult(migrationResult);
    } catch (error) {
      setResult({ success: false, error: error.message });
    } finally {
      setMigrating(false);
    }
  };

  return (
    <div className="migrate-passwords-container">
      <button 
        onClick={handleMigration} 
        disabled={migrating}
        className="migrate-button"
      >
        {migrating ? 'Migrating...' : 'Migrate Plain Text Passwords to Bcrypt'}
      </button>
      
      {result && (
        <div className={`migration-result ${result.success ? 'success' : 'error'}`}>
          {result.success ? (
            <p>Password migration completed successfully!</p>
          ) : (
            <p>Error: {result.error}</p>
          )}
        </div>
      )}
      
      <style jsx>{`
        .migrate-passwords-container {
          margin: 20px 0;
          padding: 15px;
          border: 1px solid #ddd;
          border-radius: 4px;
          background-color: #f9f9f9;
        }
        
        .migrate-button {
          background-color: #133c0b;
          color: white;
          border: none;
          padding: 10px 15px;
          border-radius: 4px;
          cursor: pointer;
        }
        
        .migrate-button:disabled {
          background-color: #cccccc;
          cursor: not-allowed;
        }
        
        .migration-result {
          margin-top: 15px;
          padding: 10px;
          border-radius: 4px;
        }
        
        .success {
          background-color: #d4edda;
          color: #155724;
        }
        
        .error {
          background-color: #f8d7da;
          color: #721c24;
        }
      `}</style>
    </div>
  );
};

export default MigratePasswordsButton;